import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full overflow-y-auto"
}
const _hoisted_2 = { class: "py-4 flex flex-row justify-start items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "font-semibold text-20px mr-4 text-black-lp-200" }
const _hoisted_4 = { class: "w-full h-full justify-center items-center flex flex-col mx-auto py-20 text-12px xxl:text-14px overflow-hidden border-t border-gray-lp-200" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "loader-list rounded-full border-2 border-t-2 h-20 w-20" }, null, -1)
const _hoisted_6 = {
  key: 1,
  class: "flex flex-row py-6 overflow-y-auto"
}
const _hoisted_7 = { class: "w-2/3 px-4 text-12px xxl:text-14px grid grid-cols-2 gap-8" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kecamatan ID", -1)
const _hoisted_9 = { class: "my-1 text-black-lp-300" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kode kecamatan", -1)
const _hoisted_11 = { class: "my-1 text-black-lp-300" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kode ursa", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Nama kecamatan", -1)
const _hoisted_14 = { class: "my-1 text-black-lp-300" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tipe area", -1)
const _hoisted_16 = { class: "my-1 text-black-lp-300" }
const _hoisted_17 = { class: "w-68" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "font-bold text-black-lp-300" }, "Kode pos", -1)
const _hoisted_19 = {
  key: 0,
  class: "my-1 text-gray-lp-300 inline-flex font-medium"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kota", -1)
const _hoisted_21 = { class: "my-1 text-black-lp-300" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kode kota", -1)
const _hoisted_23 = { class: "my-1 text-gray-lp-300 px-2 inline-flex bg-gray-lp-200 rounded font-medium" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kota asal min SLA", -1)
const _hoisted_25 = { class: "my-1 text-black-lp-300" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kota asal maks SLA", -1)
const _hoisted_27 = { class: "my-1 text-black-lp-300" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kota tujuan min SLA", -1)
const _hoisted_29 = { class: "my-1 text-black-lp-300" }
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 w-36" }, "Kota tujuan maks SLA", -1)
const _hoisted_31 = { class: "my-1 text-black-lp-300" }
const _hoisted_32 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tipe kota", -1)
const _hoisted_33 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_34 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Kode vendor", -1)
const _hoisted_35 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "COD", -1)
const _hoisted_37 = { class: "my-1 text-black-lp-300 capitalize" }
const _hoisted_38 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Potensi Misbooking?", -1)
const _hoisted_39 = { class: "my-1 text-black-lp-300" }
const _hoisted_40 = { class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400" }
const _hoisted_41 = { class: "py-3" }
const _hoisted_42 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Status lokasi", -1)
const _hoisted_43 = { class: "my-1 text-black-lp-300" }
const _hoisted_44 = { class: "flex" }
const _hoisted_45 = { class: "py-3" }
const _hoisted_46 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Tanggal dibuat", -1)
const _hoisted_47 = { class: "my-1 text-black-lp-300" }
const _hoisted_48 = { class: "text-gray-lp-500" }
const _hoisted_49 = { class: "py-3" }
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300" }, "Terakhir diperbaharui", -1)
const _hoisted_51 = { class: "my-1 text-black-lp-300" }
const _hoisted_52 = { class: "text-gray-lp-500" }
const _hoisted_53 = { class: "py-3 inline-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_button_fill = _resolveComponent("button-fill")!

  return (_ctx.isLoading === true)
    ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
        key: 0,
        onBack: _ctx.goBack
      }, null, 8, ["onBack"]))
    : (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("img", {
            src: _imports_0,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
            class: "w-5 mr-3 cursor-pointer",
            alt: "back"
          }),
          _createVNode("div", _hoisted_3, _toDisplayString(_ctx.dataDetail.name) + " - " + _toDisplayString(_ctx.dataDetail.code), 1)
        ]),
        _withDirectives(_createVNode("div", _hoisted_4, [
          _hoisted_5
        ], 512), [
          [_vShow, _ctx.isLoading]
        ]),
        (_ctx.isError)
          ? (_openBlock(), _createBlock(_component_ErrorMessage, {
              key: 0,
              errorType: _ctx.errorCause,
              onTryAgain: _ctx.fetchDistrictData
            }, null, 8, ["errorType", "onTryAgain"]))
          : (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", null, [
                  _hoisted_8,
                  _createVNode("div", _hoisted_9, _toDisplayString(_ctx.dataDetail.id), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_10,
                  _createVNode("div", _hoisted_11, _toDisplayString(_ctx.dataDetail.code), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_12,
                  _createVNode("div", {
                    class: ["my-1 text-gray-lp-300 inline-flex font-medium", 
              `${
                _ctx.dataDetail.ursaCode === '-' ? '' : 'bg-gray-lp-200 rounded px-2'
              }`
            ]
                  }, _toDisplayString(_ctx.dataDetail.ursaCode), 3)
                ]),
                _createVNode("div", null, [
                  _hoisted_13,
                  _createVNode("div", _hoisted_14, _toDisplayString(_ctx.dataDetail.name), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_15,
                  _createVNode("div", _hoisted_16, _toDisplayString(_ctx.dataDetail.areaType), 1)
                ]),
                _createVNode("div", _hoisted_17, [
                  _hoisted_18,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataDetail.destinationListZipCode, (zip, index) => {
                    return (_openBlock(), _createBlock("div", {
                      key: index,
                      class: "my-1 text-gray-lp-300 px-2 inline-flex bg-gray-lp-200 rounded mr-2 font-medium"
                    }, _toDisplayString(zip), 1))
                  }), 128)),
                  (!_ctx.dataDetail.destinationListZipCode.length)
                    ? (_openBlock(), _createBlock("div", _hoisted_19, " - "))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", null, [
                  _hoisted_20,
                  _createVNode("div", _hoisted_21, _toDisplayString(_ctx.dataDetail.cityName), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_22,
                  _createVNode("div", _hoisted_23, _toDisplayString(_ctx.dataDetail.cityCode), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_24,
                  _createVNode("div", _hoisted_25, _toDisplayString(_ctx.dataDetail.minSlaOrigin), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_26,
                  _createVNode("div", _hoisted_27, _toDisplayString(_ctx.dataDetail.maxSlaOrigin), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_28,
                  _createVNode("div", _hoisted_29, _toDisplayString(_ctx.dataDetail.minSlaDestination), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_30,
                  _createVNode("div", _hoisted_31, _toDisplayString(_ctx.dataDetail.maxSlaDestination), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_32,
                  _createVNode("div", _hoisted_33, _toDisplayString(_ctx.dataDetail.type), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_34,
                  _createVNode("div", _hoisted_35, _toDisplayString(_ctx.dataDetail.vendorCode !== "" ? _ctx.dataDetail.vendorCode : "-"), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_36,
                  _createVNode("div", _hoisted_37, _toDisplayString(_ctx.dataDetail.isCod), 1)
                ]),
                _createVNode("div", null, [
                  _hoisted_38,
                  _createVNode("div", _hoisted_39, _toDisplayString(_ctx.formatMisbookingPotential(_ctx.dataDetail.isMisbookingPotential)), 1)
                ])
              ]),
              _createVNode("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createVNode("div", _hoisted_43, [
                    _createVNode("div", _hoisted_44, [
                      _createVNode("div", {
                        class: 
                  `rounded-full px-2 py-0 font-medium capitalize ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'bg-green-lp-300'
                      : 'bg-red-lp-600'
                  } ${
                    _ctx.dataDetail.status.toLowerCase() === 'active'
                      ? 'text-green-lp-200'
                      : 'text-red-lp-500'
                  }`
                
                      }, _toDisplayString(_ctx.dataDetail.status.toLowerCase() === 'active' ? "Aktif" : "Tidak Aktif"), 3)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode("div", _hoisted_47, _toDisplayString(this.formatDate(_ctx.dataDetail.createdAt)), 1),
                  _createVNode("div", _hoisted_48, _toDisplayString(_ctx.dataDetail.createdBy), 1)
                ]),
                _createVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createVNode("div", _hoisted_51, _toDisplayString(_ctx.dataDetail.updateAt === "0001-01-01T00:00:00Z"
                ? this.formatDate(_ctx.dataDetail.createdAt)
                : this.formatDate(_ctx.dataDetail.updateAt)), 1),
                  _createVNode("div", _hoisted_52, _toDisplayString(_ctx.dataDetail.updatedBy), 1)
                ]),
                _createVNode("div", _hoisted_53, [
                  (_ctx.isEditAble)
                    ? (_openBlock(), _createBlock(_component_button_fill, {
                        key: 0,
                        onClick: _cache[2] || (_cache[2] = () => _ctx.goEdit(_ctx.id)),
                        title: "Ubah",
                        class: "px-8 bg-red-lp-300"
                      }))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
      ]))
}